import React from 'react';

import {
  Stack,
  Typography,
  List,
  ListItemButton,
  ListItemText,
  ListItemSecondaryAction,
  ListItemIcon,
} from '@mui/material';
import { useFinanceContext } from 'src/components/plaid/datasource';
import { largeCurrencyFormatter } from 'src/utils/currency-formatter';
import Scrollbar from 'src/components/scrollbar';
import Iconify from 'src/components/iconify';
import { balanceForAccount } from 'src/components/plaid/forecast/utils';

export default function AccountList() {
  const { accountViewModels: accounts } = useFinanceContext();

  return (
    <Scrollbar sx={{ width: '100%', maxHeight: 400 }}>
      <List hover="true">
        {accounts?.map((account, index) => (
          <AccountListItem key={account?.id ?? index} account={account} />
        ))}
      </List>
    </Scrollbar>
  );
}

function AccountListItem({ account, status, active, onClick }) {
  const requiresAttention = status === 'bad';
  const iconName = requiresAttention ? 'carbon:warning-filled' : 'carbon:checkmark-filled';
  const iconColor = requiresAttention ? 'red' : 'green';

  const liabilityTypes = ['loan', 'credit', 'credit card'];
  const balance = balanceForAccount(account);
  const isLiability = liabilityTypes?.includes(account.type) || balance < 0;
  const balanceColor = isLiability ? 'error.dark' : 'success.dark';

  return (
    <ListItemButton key={account.id}>
      <ListItemIcon>
        <Iconify icon={iconName} sx={{ color: iconColor }} />
      </ListItemIcon>

      <ListItemText
        primary={account.name}
        secondary={
          <Typography variant="caption" color="text.secondary">
            **** **** **** {account.mask}
          </Typography>
        }
      />
      <ListItemSecondaryAction>
        <Stack alignItems="end">
          <Typography variant="h6" color={balanceColor}>
            {largeCurrencyFormatter(balance)}
          </Typography>
        </Stack>
      </ListItemSecondaryAction>
    </ListItemButton>
  );
}
